import {
  MENU_MASTER_REQUEST, GET_MENU_MASTER_SUCCESS, ADD_MENU_MASTER_SUCCESS,
  UPDATE_MENU_MASTER_SUCCESS, DELETE_MENU_MASTER_SUCCESS, MENU_MASTER_FLAG_OFF,
} from '../constant';

const initialState = {
  items: [],
  loading: false,
  isAdded: false,
  isUpdated: false,
  isDeleted: false,
};

export const menuMasterReducer = (state = initialState, action) => {
  switch (action.type) {
    case MENU_MASTER_REQUEST:
      return { ...state, loading: true };
    case GET_MENU_MASTER_SUCCESS:
      return { ...state, loading: false, items: action.payload };
    case ADD_MENU_MASTER_SUCCESS:
      return { ...state, items: [...state.items, action.payload], isAdded: true };
    case UPDATE_MENU_MASTER_SUCCESS:
      return {
        ...state,
        isUpdated: true,
        items: state.items.map(i => i._id === action.payload._id ? action.payload : i),
      };
    case DELETE_MENU_MASTER_SUCCESS:
      return {
        ...state,
        isDeleted: true,
        items: state.items.filter(i => i._id !== action.payload),
      };
    case MENU_MASTER_FLAG_OFF:
      return { ...state, isAdded: false, isUpdated: false, isDeleted: false };
    default:
      return state;
  }
};
